module.exports = __webpack_public_path__ + "teqbahn-assets/media/38.f372bddd.png";